/**
 * Takes the underline off a link that isn't shaped like one.
 *
 * index.scss underlines every anchor under #fnReactHolder / #FnrOverlayHolder
 * on hover. That's right for a link sitting in a sentence and wrong whenever the
 * whole box is the target — a row, a card, a tile — where the underline lands on
 * whatever text happens to be inside and reads like the copy is the link.
 *
 * !important, and it has to be. The global is `#fnReactHolder a:hover`, and an
 * id beats any class a styled component can generate: your own `&:hover` is
 * (0,2,0) against its (1,1,1) and loses, which is the trap that keeps sending
 * people back to add the !important by hand. The global isn't important itself,
 * so one here settles it.
 */
const noUnderline = () => `
  &,
  &:link,
  &:visited,
  &:hover,
  &:focus,
  &:active {
    text-decoration: none !important;
  }
`;

export default noUnderline;
